<ng-template #alertHost></ng-template>

<a class="skip-link" href="#main-content">Skip to main content</a>

<!-- Header Area Start  -->


<div class="popup-backdrop" *ngIf="playerStatisticsSec">
    <div class="popup-card">
        <div class="popup-header">
            <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#ffff">
                <path
                    d="m296-320 122-122 80 80 142-141v63h80v-200H520v80h63l-85 85-80-80-178 179 56 56Zm-96 200q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h560q33 0 56.5 23.5T840-760v560q0 33-23.5 56.5T760-120H200Zm0-80h560v-560H200v560Zm0-560v560-560Z" />
            </svg>
            <h1>Statistics</h1>
        </div>
        <button class="close-btn" (click)="playerStatisticsSec = false">&times;</button>

        <div class="progress-section">
            <div class="progress-header">
                <strong>Progress:</strong>
                <strong>{{ vipProgress }}%</strong>
            </div>
            <div class="progress-bar">
                <div class="progress-fill" [style.width.%]="vipProgress"></div>
            </div>
            <div class="rank-indicators">
                <div class="rank-indicator">
                    <img src="../../../assets/imgs/vip/Ranks/{{currentRank}}.png" alt="Current Rank">
                    <span>{{ currentRank }}</span>
                </div>
                <div class="rank-indicator">
                    <img src="../../../assets/imgs/vip/Ranks/{{nextRankIcon}}.png" alt="Next Rank">
                    <span>{{ nextRankIcon }}</span>
                </div>
            </div>
        </div>

        <div class="statistics-section">
            <div class="statistics-cell">
                <span class="title">Number of Bets</span>
                <span class="value">{{ playerStatistics.numberOfBets }}</span>
            </div>
            <div class="statistics-cell">
                <span class="title">Number of Wins</span>
                <span class="value">{{ playerStatistics.numberOfWins }}</span>
            </div>
            <div class="statistics-cell">
                <span class="title">Number of Losses</span>
                <span class="value">{{ playerStatistics.numberOfLoss }}</span>
            </div>
            <div class="statistics-cell">
                <span class="title">Wagered</span>
                <span class="value"> {{playertype}}{{ playerStatistics.totalBetAmount }}</span>
            </div>

        </div>
    </div>
</div>

<div style="width: 100%;display:flex; ">
    <div class="sidenavlef bg_1 mobile_none" [ngClass]="{'sidenav': menuNames === false}">
        <div class="sidebar" [ngClass]="{'inactiveMenu': menuNames === false}">
            <div class="menu_btns">
                <button class="menuIconLines toggle-btn bg_2" [ngClass]="{'inactiveMenu': menuNames === false}"
                    (click)="openMenu()" aria-label="Open menu">
                    <!-- <span class="sr-only">Open menu</span> -->
                    <i class='fas fa-bars' aria-hidden="true" style='font-size: 24px;color: #fff;float: left;'></i>
                </button>
                <!-- <div class="btns_flx" *ngIf="menuNames"> 
                </div> -->
            </div>
            <span style="color: aqua;" class="fd comingSoon" *ngIf="errorMsg">{{errorMsg}}</span>
            <div class="search_box fd" (click)="proiderGamesAll()">
                <span class='fas fa-search'>
                </span>
                <span [ngClass]="{'inputwT' : menuNames == false}">{{'SEARCH' | translate}}</span>
            </div>
            <div class="pro_sc_T_div fd">
                <ul class="menu iconsUL">
                    <li (click)="getMenuFromPath('home')" routerLinkActive="active"
                        [class.active]="activeMenu === 'home'" [title]="'HOME' | translate">
                        <a routerLink="/home">
                            <div class="iconsList home_ic"></div>
                            <span>{{'HOME' | translate}}</span>
                        </a>
                        <span class='fas fa-caret-left arrowactive'></span>
                    </li>
                    <!-- <span style="border-bottom: 1px solid #ffffff;"></span> -->
                    <li *ngIf="providerList?.has('powerplay')" (click)="getMenuFromPath('sports')"
                        routerLinkActive="sports" [class.active]="activeMenu === 'sports'"
                        [title]="'SPORTS' | translate">
                        <a routerLink="/sports">
                            <div class="iconsList sports_ic"></div>
                            <span>{{'SPORTS' | translate}}</span>
                        </a>
                        <span class='fas fa-caret-left arrowactive'></span>
                    </li>
                    <li *ngIf="providerList?.has('pragmaticplaylivecasino') || providerList?.has('vivogaming') || providerList?.has('evolutiongv') || providerList?.has('ezugigv')"
                        (click)="getMenuFromPath('livecasino')" routerLinkActive="active"
                        [class.active]="activeMenu === 'livecasino'" [title]="'LIVE_CASINO' | translate">
                        <a routerLink="/livecasino">
                            <div class="iconsList livedealer_ic"></div>
                            <span>{{'LIVE_CASINO' | translate}}</span>
                        </a>
                        <span class='fas fa-caret-left arrowactive'></span>

                    </li>
                    <li *ngIf="providerList?.has('spribe')" (click)="getMenuFromPath('aviator')"
                        routerLinkActive="active" [class.active]="activeMenu === 'aviator'"
                        [title]="'AVIATOR' | translate">
                        <a routerLink="/aviator">
                            <div class="iconsList crash_ic"></div>
                            <span>{{'AVIATOR' | translate}}</span>
                        </a>
                        <span class='fas fa-caret-left arrowactive'></span>
                    </li>

                    <li *ngIf="providerList?.has('ballagames')" (click)="getMenuFromPath('ballagames')"
                        routerLinkActive="active" [class.active]="activeMenu === 'ballagames'"
                        [title]="'BALLA_GAMES' | translate">
                        <a routerLink="/ballagames">
                            <div class="iconsList Topgames_ic"></div>
                            <span>{{'BALLA_GAMES' | translate}}</span>
                        </a>
                        <span class='fas fa-caret-left arrowactive'></span>

                    </li>
                    <li (click)="getMenuFromPath('slots')" routerLinkActive="active"
                        [class.active]="activeMenu === 'slots'" [title]="'SLOTS' | translate">
                        <a routerLink="/slots">
                            <div class="iconsList slots_ic"></div>
                            <span>{{'SLOTS' | translate}}</span>
                        </a>
                        <span class='fas fa-caret-left arrowactive'></span>

                    </li>


                    <li *ngIf="providerList?.has('pragmaticplaylivecasino') || providerList?.has('vivogaming') || providerList?.has('evolutiongv') || providerList?.has('ezugigv')"
                        (click)="getMenuFromPath('roulette')" routerLinkActive="active"
                        [class.active]="activeMenu === 'roulette'" [title]="'ROULETTE' | translate">
                        <a routerLink="/roulette">
                            <div class="iconsList roulette_ic"></div>
                            <span>{{'ROULETTE'|translate}}</span>
                        </a>
                        <span class='fas fa-caret-left arrowactive'></span>

                    </li>

                    <li *ngIf="providerList?.has('pragmaticplaylivecasino') || providerList?.has('vivogaming') || providerList?.has('evolutiongv') || providerList?.has('ezugigv')"
                        (click)="getMenuFromPath('blackjack')" routerLinkActive="active"
                        [class.active]="activeMenu === 'blackjack'" [title]="'BLACKJACK' | translate">
                        <a routerLink="/blackjack">
                            <div class="iconsList blackjack_ic"></div>
                            <span>{{'BLACKJACK' | translate}}</span>
                        </a>
                        <span class='fas fa-caret-left arrowactive'></span>

                    </li>

                    <li *ngIf="providerList?.has('pragmaticplaylivecasino') || providerList?.has('vivogaming') || providerList?.has('evolutiongv') || providerList?.has('ezugigv')"
                        (click)="getMenuFromPath('baccarat')" routerLinkActive="active"
                        [class.active]="activeMenu === 'baccarat'" [title]="'BACCARAT' | translate">
                        <a routerLink="/baccarat">
                            <div class="iconsList baccarat_ic"></div>
                            <span>{{'BACCARAT' | translate}}</span>
                        </a>
                        <span class='fas fa-caret-left arrowactive'></span>

                    </li>

                    <li (click)="getMenuFromPath('lottery')" routerLinkActive="active"
                        [class.active]="activeMenu === 'lottery'" [title]="'LOTTERY' | translate">
                        <a routerLink="/lottery">
                            <div class="iconsList lottery_ic"></div>
                            <span>{{'LOTTERY' | translate}}</span>
                        </a>
                        <span class='fas fa-caret-left arrowactive'></span>

                    </li>

                    <li (click)="getMenuFromPath('promotions')" routerLinkActive="active"
                        [class.active]="activeMenu === 'promotions'" [title]="'PROMOTIONS' | translate">
                        <a routerLink="/promotions">
                            <div class="iconsList Promotions_ic"></div>
                            <span>{{'PROMOTIONS' | translate}}</span>
                        </a>
                        <span class='fas fa-caret-left arrowactive'></span>

                    </li>
                    <li (click)="getMenuFromPath('providers')" routerLinkActive="active"
                        [class.active]="activeMenu === 'providers'" [title]="'PROVIDERS' | translate">
                        <a routerLink="/providers">
                            <div class="iconsList provider_ic"></div>
                            <span>{{'PROVIDERS' | translate}}</span>
                        </a>
                        <span class='fas fa-caret-left arrowactive'></span>

                    </li>

                    <li (click)="getMenuFromPath('profile')" routerLinkActive="active"
                        [class.active]="activeMenu === 'profile'" [title]="'MY_ACCOUNT' | translate"
                        *ngIf="playerLoggedIn">
                        <a (click)="myprofile()">
                            <div class="iconsList myaccount_ic"></div>
                            <span>{{'MY_ACCOUNT' | translate}}</span>

                        </a>
                        <!-- <span class='fas fa-caret-left arrowactive'  ></span> -->

                        <span class="float_left" (click)="myprofile()">
                            <i *ngIf="openProfile" class='fas fa-angle-up'></i>
                            <i *ngIf="!openProfile" class='fas fa-angle-down'></i>
                        </span>

                    </li>
                    <div class="flex_cl" *ngIf="openProfile" #profileDropdown>

                        <li routerLinkActive="active" [title]="'PROFILE' | translate">
                            <a routerLink="/profile">
                                <div class="iconsList profile_ic"></div>
                                <span>{{'PROFILE' | translate}}</span>
                            </a>
                            <span class='fas fa-caret-left arrowactive'></span>


                        </li>

                        <li routerLinkActive="active" [title]="'MY_BALANCE' | translate">
                            <a routerLink="/mybalance">
                                <div class="iconsList My_balance_ic"></div>
                                <span>{{'MY_BALANCE' | translate}}</span>
                            </a>
                            <span class='fas fa-caret-left arrowactive'></span>

                        </li>

                        <li routerLinkActive="active" [title]="'TRANSACTION_HISTORY' | translate">
                            <a routerLink="/transactionhistory">
                                <div class="iconsList transactions_ic"></div>
                                <span>{{'TRANSACTION_HISTORY' | translate}}</span>
                            </a>
                            <span class='fas fa-caret-left arrowactive'></span>

                        </li>


                        <li routerLinkActive="active" [title]="'GAME_HISTORY' | translate">
                            <a routerLink="/casinogamehistory">
                                <div class="iconsList Recently_P_ic"></div>
                                <span>{{'GAME_HISTORY' | translate}}</span>
                            </a>
                            <span class='fas fa-caret-left arrowactive'></span>

                        </li>
                    </div>
                </ul>
            </div>

        </div>
    </div>
    <div class="rightsidenav bg_7" [ngClass]="{'rightside': menuNames === false}">
        <div class="container321">
            <section class="apk" *ngIf="isApkDownload">
                <div class="app-banner">

                    <button class="close-btn-apk" (click)="isApkDownload = false">✕</button>

                    <img src="assets/images/android.png" class="app-icon" />
                     <!-- <i class="fa fa-android " style="font-size: 24px;"></i> -->

                    <div class="text-area">
                        {{ 'APP_DOWNLOAD_TEXT' | translate }}
                    </div>


                    <a href="https://zupwinbd.com/download/mobile/zupwinbd.apk" class="download-btn" target="_blank">
                        {{ 'DOWNLOAD_NOW' | translate }}
                    </a>
                </div>
            </section>
            <header class="header bg_7 " [ngClass]="{'is-apk-header': isApkDownload, 'headerWid': menuNames === false}">

                <section class="top-header container321 ">
                    <div class="fd df_jc_sb">
                        <div class="left-content df_alc">
                            <ul class="left-list ">
                                <li class="mobile_none">
                                    <a routerLink="/home" class="fd text-center" (click)="closeMenuNames('close')">
                                        <img class="main_logo darkMode" src="../../../assets/siteImg/sitelogo.svg"
                                            loading="lazy" alt="logo" width="200">
                                    </a>
                                </li>
                                <li class="mobile_block">
                                    <a routerLink="/home" class="fd text-center" (click)="closeMenuNames('close')">
                                        <img class="main_logo darkMode" src="../../../assets/siteImg/logo_ico.png"
                                            loading="lazy" alt="logo" width="40">
                                    </a>
                                </li>
                            </ul>
                        </div>

                        <div class="center-content df_alc" *ngIf="playerLoggedIn">
                            <ul class="center-list df">
                                <!-- <li *ngIf="gifLoader" class="loader-container">
                                    <img src="assets/siteImg/Loader.gif" alt="Loading..." class="loader-gif">
                                </li> -->
                                <li class="balance-sec" #balanceDropdown>
                                    <a (click)="toggleDropdown($event)">
                                        <!-- Bal: <span> {{playertype}}{{ balance }}</span> -->
                                        <span class="df align-items-center balance-txt"> {{playertype}} {{ balance }}

                                            <!-- <span class="m_l_5 doller_symbol-icon m_r_5">{{playertype}}</span> -->
                                            <!-- <i class="fas fa-coins" style="color: gold;"></i> -->
                                            <!-- <svg width="30" height="30" viewBox="0 0 16 44" fill="none"
                                                xmlns="http://www.w3.org/2000/svg">
                                                <circle cx="7.85714" cy="22.0002" r="7.85714" fill="#EAC74A" />
                                                <path
                                                    d="M8.23072 25.9429H7.28787V25.066C5.76044 24.9246 4.9873 24.1326 4.9873 22.9351V22.8786H6.00558V23.0294C6.00558 23.7837 6.44872 24.1609 7.83472 24.1609C9.04158 24.1609 9.46587 23.8969 9.46587 23.3029C9.46587 22.756 9.1453 22.5486 8.34387 22.3977L6.79758 22.1431C5.73215 21.9546 4.97787 21.4643 4.97787 20.4271C4.97787 19.5786 5.62844 18.7206 7.28787 18.6074V17.74H8.23072V18.6169C9.70158 18.7771 10.3804 19.6351 10.3804 20.7477V20.8043H9.37158V20.6817C9.37158 19.9086 8.90958 19.522 7.59901 19.522C6.44872 19.522 5.99615 19.8049 5.99615 20.3706C5.99615 20.9174 6.31672 21.0966 7.06158 21.2569L8.59844 21.5209C9.86187 21.7471 10.4842 22.3223 10.4842 23.2463C10.4842 24.1326 9.81472 24.9623 8.23072 25.0754V25.9429Z"
                                                    fill="#1E1E1E" />
                                            </svg> -->
                                        </span>
                                        <span>
                                            <i [class.fa-angle-up]="profileHeader"
                                                [class.fa-angle-down]="!profileHeader" class="fas"></i>
                                        </span>
                                    </a>
                                    <ul *ngIf="profileHeader" class="headerDrop">
                                        <!-- <li>{{ playerName }}</li> -->
                                        <li>Cash: {{playertype}} {{ cashuser }}</li>
                                        <li>Bonus: {{playertype}} {{ bounsuser }}</li>
                                        <!-- <li>Loyalty Points: {{ userCompoints }}</li> -->
                                    </ul>
                                </li>
                                <span class="mobile_none" routerLink="/deposit" *ngIf="hidedeposit">
                                    <li class="wallet_btn "> <img src="../../../assets/siteImg/Wallet_H.svg"
                                            alt="Deposit" width="30" height="30">{{'DEPOSIT' | translate}}</li>
                                </span>
                                <li routerLink="/deposit" class="wallet_btn mobile_block" *ngIf="hidedeposit"> <img
                                        src="../../../assets/siteImg/Wallet_H.svg" alt="wallet" width="45" height="40">
                                </li>
                            </ul>
                        </div>

                        <div class="right-content mobile_setting">

                            <ul class="right-list " *ngIf="!playerLoggedIn">

                                <li *ngIf="!playerLoggedIn" class="login">
                                    <button (click)="showPopUp('LOGIN')" class="newLoginRegister">
                                        {{'LOGIN' | translate }}
                                    </button>
                                </li>
                                <li *ngIf="!playerLoggedIn" class="joinBG">
                                    <button (click)="showPopUp('REGISTER')" class="newLoginRegister">
                                        {{'JOIN_US' | translate}}
                                    </button>
                                </li>
                                <li class="lang_icon" style="background: #01000f;" (click)="toggleDropdown1()">
                                    <img [src]="'../../../assets/siteImg/language_icon/' + selectedLang + '.svg'"
                                        width="30" alt="language" />
                                    <span class="mobile_none" style="align-items: center;">

                                        {{ selectedLang === 'BN' ? 'Bangla' : 'English' }}
                                        <i class="fas fa-angle-down"></i>
                                    </span>
                                    <ng-container *ngIf="openClose">
                                        <ul class="drop_lang" (click)="$event.stopPropagation()">
                                            <li class="lang_icon lang_icon1" *ngFor="let lang of languages"
                                                (click)="changeLanguage(lang.code,  $event)">
                                                <img [src]="'../../../assets/siteImg/language_icon/' + lang.code + '.svg'"
                                                    width="30" alt="language" />
                                                {{ lang.label }}
                                            </li>
                                        </ul>
                                    </ng-container>

                                </li>


                            </ul>
                            <ul *ngIf="playerLoggedIn" class="right_def_li">
                                <li #avatarDropdown>
                                    <a (click)="toggleDropdownAvathar($event)">
                                        <span class="fas fa-user-circle" style="font-size: 34px;color: #fff;"></span>
                                    </a>
                                    <ul *ngIf="profileAvathar" class="headerDrop Po_Av">

                                        <li class="userProfile">
                                            <ul class="fd">
                                                <li (click)="toggleDropdownAvathar($event)" class="userProfile"
                                                    style="border-bottom: 1px solid var(--border_clr);"
                                                    routerLink="/profile">
                                                    <span class="fas fa-user-circle"
                                                        style="font-size:34px;color:#fff"></span>
                                                    {{profile.login}}
                                                </li>
                                                <li class="flex_div">
                                                    <span>{{vipName1}}</span>
                                                    <span> <img src="../../assets/siteImg/leavelC/{{vipName}}.png"
                                                            width="25" height="25" alt="level.name"> {{vipName}}</span>
                                                </li>
                                            </ul>
                                        </li>

                                        <li (click)="toggleDropdownAvathar($event)" routerLink="/cashout"
                                            *ngIf="hidecashout">
                                            <i class="fas fa-wallet" style="font-size: 15px; margin-right: 3px;"></i>
                                            {{'CASHOUT' | translate}}
                                        </li>

                                        <li (click)="toggleDropdownAvathar($event)" routerLink="/transactionhistory">
                                            <i class='fas fa-exchange-alt'
                                                style='font-size:15px; margin-right: 3px;'></i>
                                            {{'TRANSACTION_HISTORY' | translate}}
                                        </li>
                                        <li (click)="toggleDropdownAvathar($event)" routerLink="/casinogamehistory">
                                            <i class='fas fa-history' style='font-size:15px;margin-right: 3px;'></i>

                                            {{'GAME_HISTORY' | translate}}
                                        </li>

                                        <!-- <li (click)="toggleDropdownAvathar($event)" routerLink="/exchange-currency">
                                            <i class='fas fa-exchange-alt'
                                                style='font-size:15px;margin-right: 3px;'></i>
                                            Exchange
                                        </li>
 
                                        <li (click)="openLiveSupport()"> 
                                            <i class="fas fa-headset" style="font-size: 15px; margin-right: 3px;"></i>
                                            Live Support
                                        </li> -->

                                        <li (click)="toggleDropdownAvathar($event)" routerLink="/profile"><i
                                                class='fas fa-user-alt' style='font-size: 15px;margin-right: 3px;'></i>
                                            {{'PROFILE' | translate}}</li>

                                        <li (click)="showLogOutPopup()"> <span class='fas fa-sign-out-alt'
                                                style='font-size:15px;margin-right: 3px;color: #f00;'></span> {{'LOGOUT'
                                            | translate}}
                                        </li>
                                    </ul>
                                </li>
                                <li class="lang_icon" style="background: #01000f;" (click)="toggleDropdown1()">
                                    <img [src]="'../../../assets/siteImg/language_icon/' + selectedLang + '.svg'"
                                        width="30" alt="language" />
                                    <span class="mobile_none" style="align-items: center;">

                                        {{ selectedLang === 'BN' ? 'Bangla' : 'English' }}
                                        <i class="fas fa-angle-down"></i>
                                    </span>
                                    <ng-container *ngIf="openClose">
                                        <ul class="drop_lang" (click)="$event.stopPropagation()">
                                            <li class="lang_icon lang_icon1" *ngFor="let lang of languages"
                                                (click)="changeLanguage(lang.code,  $event)">
                                                <img [src]="'../../../assets/siteImg/language_icon/' + lang.code + '.svg'"
                                                    width="30" alt="language" />
                                                {{ lang.label }}
                                            </li>
                                        </ul>
                                    </ng-container>

                                </li>

                            </ul>
                        </div>
                    </div>
                </section>
            </header>


            <!-- <div *ngIf="statusMessage" [ngStyle]="{'margin-top': !playerLoggedIn ? '90px' : '0px'}">
                <app-carousel></app-carousel>
            </div> -->
            <div class="black_cover" *ngIf="logoutPopup" (click)="hideLogOutPopup()">
            </div>
            <div class="logoutpopup" *ngIf="logoutPopup">
                <i class='fas fa-times' style='font-size:24px;color: #fff;' (click)="hideLogOutPopup()"></i>
                <div class="flexContent">
                    <i class='fas fa-user-alt frist'></i>
                    <i class='fas fa-user-alt second'></i>
                </div>
                <h3>{{'LOGOUT_CONFIRM' | translate}}</h3>
                <div class="flexContent1">
                    <button (click)="hideLogOutPopup()">{{'NO' | translate}}</button>
                    <button (click)="onClickLogout()">{{'YES' | translate}}</button>
                </div>

            </div>

            <div class="fd " [ngStyle]="{'margin-top': isApkDownload ? '100px' : '60px'}">
                <!-- <div class="  fd" [ngStyle]="{'margin-top': playerLoggedIn ? '90px' : '0px'}"> -->
                <router-outlet></router-outlet>
                <!-- <div *ngIf="allproiderGames" >
                    <a class="btn-whats pulse" href="https://wa.me/16728246224" target="_blank">
                      
                      <i class='fab fa-whatsapp'></i>
                    </a>
                  </div> -->
            </div>

            <div class="fd" *ngIf="router.url !== '/providers' && router.url !== '/home'">
                <div class="container321 fd p_0">
                    <app-footer-provider></app-footer-provider>
                </div>
            </div>
            <div class="fd" *ngIf="allproiderGames">
                <div class="black_cover" *ngIf="allproiderGames" (click)="proiderGamesClose()"></div>
                <div class="fd container321 gamesPopup bg_7" *ngIf="allproiderGames"
                    style="z-index: 100000 !important;">
                    <div (click)="proiderGamesClose()" class="closeComp"><i class='fas fa-times'
                            style='font-size:24px'></i></div>
                    <app-all-gameprovider (gameLaunched)="proiderGamesClose()" class="fd"></app-all-gameprovider>
                </div>
            </div>
        </div>
        <div class="fd bg_8">
            <div class="container321">
                <app-footer></app-footer>
            </div>
        </div>
    </div>
    <div class="mobile_block" *ngIf="statusMessage">
        <div class="button-container ">
            <!-- <div routerLink="/home" class="dmg">
                <div class="spin">◌</div>
            </div> -->
            <button *ngFor="let link of links; let i = index" class="mobile-button" [class.active]="link.active"
                (click)="onLinkClick(i)"> <i *ngIf="link.name !== 'AVIATOR'" class='fas ' [ngClass]="link.icon"
                    style='font-size:18px'></i> <img *ngIf="link.name == 'AVIATOR'"
                    src="../../../assets/siteImg/IconsB/Aviator.svg" alt="Aviator" width="26" height="26"
                    style="margin: auto;"> {{ link.name | translate}}</button>
        </div>
    </div>

</div>

<!-- ====================================== Avtar Popup - Start ====================================== -->
<div class="black_cover" *ngIf="showAvtars"></div>
<div class="popup_1 pop_sm" *ngIf="showAvtars">
    <span class="casino_pupop" (click)="onChangeAvtar($event)">
        <i class='fas fa-times'></i>
    </span>
    <div class="avtar-container">
        <div *ngFor="let avtar of avatarList">
            <img src="data:image/png;base64,{{avtar.imageData}}" alt="" (click)="selectAvtar(avtar)" />
        </div>
    </div>
    <div class="avtar-preview-container">
        <div>
            <span *ngIf="previewAvtar"> Preview:</span>
            <span *ngIf="!previewAvtar">please select above to set</span>
            <img [src]="previewAvtar" class="previewAvtarImage" alt="Avatar" />
        </div>

        <button type="button" class="btn_1" [disabled]="!previewAvtar" (click)="setAvtar()">
            Set Avatar
        </button>
    </div>
</div>

<!-- ====================================== Avtar Popup - End ====================================== -->

<div class="black_cover" *ngIf="casinogamessuccessPop" (click)="casinogamessuccessPopClose()"></div>
<div class="popup_1 pop_sm" *ngIf="casinogamessuccessPop">
    <span class="casino_pupop" (click)="casinogamessuccessPopClose()"> <i class='fas fa-times'></i></span>
    <div class="soon font_16">
        {{casinomessage | translate}} <br> <br>
        <button class="btn_comSoon" (click)="casinogamessuccessPopClose()"> {{'OK' | translate}}</button>
    </div>
</div>

<div class="black_cover" *ngIf="sessionExpiresuccessPop"></div>
<div class="modern-popup-top" *ngIf="sessionExpiresuccessPop">
    <div class="popup-content">
        <div class="df">
            <div class="icon-container">
                <svg class="session-icon" viewBox="0 0 24 24">
                    <path fill="currentColor"
                        d="M11,15H13V17H11V15M11,7H13V13H11V7M12,2C6.47,2 2,6.5 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4A8,8 0 0,1 20,12A8,8 0 0,1 12,20Z" />
                </svg>
            </div>

            <div class="text-content">
                <h3 class="popup-title">{{'Session Alert' | translate}}</h3>
                <p class="popup-message">{{sessionmessage | translate}}</p>
            </div>

            <button class="modern-close-btn" (click)="sessionExpiresuccessPopClose()">
                <svg viewBox="0 0 24 24">
                    <path fill="currentColor"
                        d="M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z" />
                </svg>
            </button>
        </div>
        <div class="popup-actions">
            <button class="modern-action-btn" (click)="sessionExpiresuccessPopClose()">
                {{'Got It' | translate}}
            </button>
        </div>
    </div>

</div>



<!-- ##################### Deposit message popup ################################# -->

<div class="fullpage mobile_block" [class.show]="menushow">
    <div class="mobile_side_sub">
        <span>{{errorMsg}}</span>

        <div (click)="closeMenu();proiderGamesAll() " class="search_box bb_line">
            <span class='fas fa-search'>
            </span>
            <input type="text" [placeholder]="'SEARCH' | translate" name="search" id="search_ID"
                [ngClass]="{'inputwT' : menuNames == false}">
        </div>
        <div class="mB_Tb m_b_50">
            <ul class="iconsUL">
                <li (click)="closeMenu()" routerLinkActive="active">
                    <a routerLink="/home">
                        <div class="iconsList home_ic"></div>
                        <span>{{'HOME' | translate}}</span>
                    </a>
                    <span class='fas fa-caret-left arrowactive'></span>

                </li>

                <li *ngIf="providerList?.has('powerplay') " (click)="closeMenu()" routerLinkActive="active">
                    <a routerLink="/sports">
                        <div class="iconsList sports_ic"></div>
                        <span>{{'SPORTS' | translate}}</span>
                    </a>
                    <span class='fas fa-caret-left arrowactive'></span>
                </li>

                <li *ngIf="providerList?.has('pragmaticplaylivecasino') || providerList?.has('vivogaming') || providerList?.has('evolutiongv') || providerList?.has('ezugigv')"
                    (click)="closeMenu()" routerLinkActive="active">
                    <a routerLink="/livecasino">
                        <div class="iconsList livedealer_ic"></div>
                        <span>{{'LIVE_CASINO' | translate}}</span>
                    </a>
                    <span class='fas fa-caret-left arrowactive'></span>
                </li>

                <li *ngIf="providerList?.has('spribe')" (click)="closeMenu()" routerLinkActive="active">
                    <a routerLink="/aviator">
                        <div class="iconsList crash_ic"></div>
                        <span>{{'AVIATOR' | translate}}</span>
                    </a>
                    <span class='fas fa-caret-left arrowactive'></span>
                </li>

                <li *ngIf="providerList?.has('ballagames')" (click)="closeMenu()" routerLinkActive="active">
                    <a routerLink="/ballagames">
                        <div class="iconsList Topgames_ic"></div>
                        <span>{{'BALLA_GAMES' | translate}}</span>
                    </a>
                    <span class='fas fa-caret-left arrowactive'></span>
                </li>
                <li (click)="closeMenu()" routerLinkActive="active">
                    <a routerLink="/slots">
                        <div class="iconsList slots_ic"></div>
                        <span>{{'SLOTS' | translate}}</span>
                    </a>
                    <span class='fas fa-caret-left arrowactive'></span>
                </li>

                <li *ngIf="providerList?.has('pragmaticplaylivecasino') || providerList?.has('vivogaming') || providerList?.has('evolutiongv') || providerList?.has('ezugigv')"
                    (click)="closeMenu()" routerLinkActive="active">
                    <a routerLink="/roulette">
                        <div class="iconsList roulette_ic"></div>
                        <span>{{'ROULETTE'|translate}}</span>
                    </a>
                    <span class='fas fa-caret-left arrowactive'></span>
                </li>

                <li *ngIf="providerList?.has('pragmaticplaylivecasino') || providerList?.has('vivogaming') || providerList?.has('evolutiongv') || providerList?.has('ezugigv')"
                    (click)="closeMenu()" routerLinkActive="active">
                    <a routerLink="/blackjack">
                        <div class="iconsList blackjack_ic"></div>
                        <span>{{'BLACKJACK' | translate}}</span>
                    </a>
                    <span class='fas fa-caret-left arrowactive'></span>
                </li>

                <li *ngIf="providerList?.has('pragmaticplaylivecasino') || providerList?.has('vivogaming') || providerList?.has('evolutiongv') || providerList?.has('ezugigv')"
                    (click)="closeMenu()" routerLinkActive="active">
                    <a routerLink="/baccarat">
                        <div class="iconsList baccarat_ic"></div>
                        <span>{{'BACCARAT' | translate}}</span>
                    </a>
                    <span class='fas fa-caret-left arrowactive'></span>
                </li>
                <li (click)="closeMenu()" routerLinkActive="active">
                    <a routerLink="/promotions">
                        <div class="iconsList Promotions_ic"></div>
                        <span>{{'PROMOTIONS'|translate}}</span>
                    </a>
                    <span class='fas fa-caret-left arrowactive'></span>
                </li>

                <li (click)="closeMenu()" routerLinkActive="active">
                    <a routerLink="/providers">
                        <div class="iconsList provider_ic"></div>
                        <span>{{'PROVIDERS' | translate}}</span>
                    </a>
                    <span class='fas fa-caret-left arrowactive'></span>

                </li>

                <li routerLinkActive="active" *ngIf="playerLoggedIn">
                    <a (click)="myprofile()">
                        <div class="iconsList myaccount_ic"></div>
                        <span>{{'MY_ACCOUNT' | translate}}</span>

                    </a>
                    <span class="float_left" (click)="myprofile()">
                        <i *ngIf="openProfile" class='fas fa-angle-up'></i>
                        <i *ngIf="!openProfile" class='fas fa-angle-down'></i>
                    </span>

                </li>





                <div class="flex_cl" *ngIf="openProfile">

                    <li (click)="closeMenu()" routerLinkActive="active">
                        <a routerLink="/profile">
                            <div class="iconsList profile_ic"></div>
                            <span>{{'PROFILE' | translate}}</span>

                        </a>
                        <span class='fas fa-caret-left arrowactive'></span>
                    </li>
                    <li (click)="closeMenu()" routerLinkActive="active">
                        <a routerLink="/mybalance">
                            <div class="iconsList My_balance_ic"></div>
                            <span>{{'MY_BALANCE' | translate}}</span>
                        </a>
                        <span class='fas fa-caret-left arrowactive'></span>
                    </li>

                    <li (click)="closeMenu()" routerLinkActive="active">
                        <a routerLink="/transactionhistory">
                            <i class='fas fa-exchange-alt' style='font-size:15px; margin-right: 3px;'></i>
                            <span>{{'TRANSACTION_HISTORY' | translate}}</span>
                        </a>
                        <span class='fas fa-caret-left arrowactive'></span>
                    </li>

                    <!-- <li (click)="closeMenu()" routerLinkActive="active">
                        <a routerLink="/exchange-currency">
                            <div class="iconsList exchange_ic"></div>
                            <span>Trade</span>
                        </a>
                        <span class='fas fa-caret-left arrowactive'></span>
                    </li> -->

                    <li (click)="closeMenu()" routerLinkActive="active">
                        <a routerLink="/casinogamehistory">
                            <i class='fas fa-history' style='font-size:15px;margin-right: 3px;'></i>
                            <span>{{'GAME_HISTORY' | translate}}</span>
                        </a>
                        <span class='fas fa-caret-left arrowactive'></span>
                    </li>

                </div>
                <li (click)="closeMenu()" *ngIf="playerLoggedIn">
                    <a (click)="showLogOutPopup()">
                        <i class='fas fa-sign-out-alt' style='font-size:20px;margin-right: 8px;color: #f00;'></i>
                        <span>{{'LOGOUT' | translate}}</span>

                    </a>
                    <span class='fas fa-caret-left arrowactive'></span>
                </li>

            </ul>

        </div>

    </div>